module.exports = __webpack_public_path__ + "img/checksurat-min.beec41af.png";